export default interface BusinessError<T> {
  code: string;
  data?: T;
}

export function isBusinessError<T>(obj: unknown): obj is BusinessError<T> {
  return typeof obj === 'object' && obj !== null && 'code' in obj && 'data' in obj;
}
